import React from 'react';
import { VerticalTimelineElement } from 'react-vertical-timeline-component';
import Title from './Title';
import { UserType } from '../../Models/UserType';

interface Props {
    title: string;
    isDay?: boolean;
    userType: UserType | undefined;
    time: string;
}

const TimelineElement = ({
    title, 
    userType, 
    time,
    isDay = false
}: Props) => {
    
    if (isDay && userType === UserType.EveningGuest) {
        return <></>;
    }

    return (
        <VerticalTimelineElement
            icon={<span className="text-3xl"></span>}
            iconClassName="bg-[rgba(30,58,138)]"
            contentStyle={{ background: 'rgb(30, 58, 138, 0.7)', color: '#fff', height: '5rem', display: 'flex', alignItems: 'center' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(30, 58, 138, 0.7)' }}
            className="timeline-element"
        >
            <div className="grid grid-cols-10 items-center w-[97%] mx-auto">
                <Title size="1" className="col-span-2 pt-0">{time}</Title>
                <Title size="1" className="col-span-8 pt-0">{title}</Title>
            </div>
        </VerticalTimelineElement>
    );
}

export default TimelineElement;